<template>
  <div>
    <section>
      <div class="container">
        <div class="text-center">
          <h2 class="font-size-medium font-weight-bold">Minhas Assinaturas</h2>
        </div>
      </div>
    </section>

    <!-- CONTENT -->
    <section class="mt-4 mt-lg-5">
      <div class="container">
        <!-- SCRIV PRO SUB -->
        <div class="mb-4" v-if="scriv_pro_subscription">
          <div class="text-center mb-3">
            <h3 class="font-size-regular font-weight-bold mb-3">Assinatura Scriv Pro</h3>
          </div>
          <div>
            <SubscriptionCard
              :subscription="scriv_pro_subscription"
              :expandable="true"
              @subscription-destroyed="reset"
            />
          </div>
        </div> <!-- END SCRIV PRO SUB -->
        <div class="text-center">
          <h3 class="font-size-regular font-weight-bold mb-3">Assinaturas de comunidades</h3>
        </div>
        <div class="mb-4 text-center">
          <router-link
            class="btn btn-outline-color2 btn-sm"
            :to="{ name: 'groups.index' }"
          >
            Ver comunidades disponíveis
          </router-link>
        </div>
        <template
          v-if="loader && group_subscriptions.length == 0"
        >
          <Loader
            color="color2"
            size="big"
          />
        </template>
        <template v-else>
          <div>
            <template
              v-if="group_subscriptions.length > 0"
            >
              <div>
                <div
                  class="mb-3 mb-lg-4"
                  v-for="subscription in group_subscriptions"
                  :key="subscription.id"
                >
                  <SubscriptionCard
                    :subscription="subscription"
                    :expandable="true"
                    @subscription-destroyed="reset"
                  />
                </div>
              </div>
              <div
                class="mt-4 mt-lg-5 text-center"
                v-if="isLoadMoreVisible"
              >
                <Button
                  class="btn-outline-color2"
                  :loading="loader"
                  @click="loadMore"
                >
                  Carregar mais
                </Button>
              </div>
            </template>
            <template v-else>
              <p class="text-center">Você ainda não possui assinaturas</p>
            </template>
          </div>
        </template>
      </div>
    </section> <!-- END CONTENT -->

  </div>
</template>

<script>

import SubscriptionsService from '@/modules/subscriptions/services/subscriptions-service'

// import BookThumbCard from '@/components/books/BookThumbCard.vue'
import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'
import SubscriptionCard from '@/components/subscriptions/SubscriptionCard'
// import OrderCard from '@/components/orders/OrderCard'

export default {
  components: {
    Button,
    Loader,
    SubscriptionCard
  },
  metaInfo () {
    return {
      title: 'Minhas Assinaturas',
      meta: [
        { vmid: 'og-title', name: 'og:title', content: 'Minhas Assinaturas' }
      ]
    }
  },
  data () {
    return {
      scriv_pro_subscription: null,
      group_subscriptions: [],
      loader: false,
      isLoadMoreVisible: true,
      page: 1
    }
  },
  created () {
    this.getSubscriptions('group')
    this.getSubscriptions('scriv_pro')
  },
  methods: {
    async getSubscriptions (type) {
      this.loader = true
      try {
        const subscriptions = await SubscriptionsService.getSubscriptions({ page: type === 'group' ? this.page : 1, type: type })
        if (type === 'group') {
          this.group_subscriptions = [...this.group_subscriptions, ...subscriptions]
          this.isLoadMoreVisible = subscriptions.length > 0
        } else if (type === 'scriv_pro') {
          if (subscriptions.length > 0) this.scriv_pro_subscription = subscriptions[0]
        }
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    loadMore () {
      this.page++
      this.getSubscriptions()
    },
    reset () {
      this.scriv_pro_subscription = null
      this.group_subscriptions = []
      this.page = 1
      this.loader = false
      this.isLoadMoreVisible = true

      this.getSubscriptions('group')
      this.getSubscriptions('scriv_pro')
    }
  }
}
</script>
